import { applyMiddleware, combineReducers, legacy_createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import thunk from 'redux-thunk';
import { api_middleware, exercise_reducer, global_reducer, patient_reducer, questions_reducer } from '../../reducers';
import migrations from './migrations';

const appReducer = combineReducers({
  api_middleware,
  exercise_reducer,
  global_reducer,
  patient_reducer,
  questions_reducer
});

export const rootReducer = (state, action) => {
  if (action.type === 'RESET') {
    storage.removeItem('persist:root');
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const persistConfig = {
  key: 'root',
  // TODO: IMPORTANT!!!
  version: 25, //  <---- increment this version together with migrations key every time when you add a new property to any reducer
  storage,
  migrate: createMigrate(migrations, { debug: true }),
  blacklist: ['messenger_reducer']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default () => {
  const store = legacy_createStore(persistedReducer, composeWithDevTools(applyMiddleware(thunk)));
  const persistor = persistStore(store);
  return { store, persistor };
};
